import { useQuery } from '@tanstack/react-query';

import { INTERVIEW_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';
import { useStaffSession } from '@/hooks/auth';

const useInterviewAttempts = (applicantID: string, isEnabled: boolean = true) => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: INTERVIEW_KEYS.attempts(applicantID),
    queryFn: async () => errorUtils.unwrap(await interviewsService.readAttempts(applicantID)),
    enabled: isEnabled && applicantID.length > 0 && session?.stage === 'ready',
  });
};

export {
  useInterviewAttempts,
};
